module.exports = __webpack_public_path__ + "static/media/banner.b32bcbee.jpg";